<template>
  <SearchFormWrapper>
    <form
      autocomplete="off"
      class="flex items-center gap-2"
      @submit.prevent="$emit('search', JSON.parse(JSON.stringify(searchParams)))"
    >
      <SearchQueryTextInput v-model="searchParams.search" />

      <SwitchInputWrapper>
        <SwitchInput
          v-model="searchParams.includeArchived"
          text="Show Archived"
        />
      </SwitchInputWrapper>

      <SearchButton />
    </form>
  </SearchFormWrapper>
</template>

<script setup>
import { ref } from 'vue';

import { SearchFormWrapper } from '@/components/forms';
import { SwitchInput, SearchQueryTextInput } from '@/components/form-inputs';
import { SwitchInputWrapper } from '@/components/wrappers';
import { SearchButton } from '@/components/buttons';

defineEmits(['search']);

const searchParams = ref({
  search: null,
  includeArchived: false,
});
</script>
